// A HISTÓRIA DO NAVEGADOR COM ENDEREÇOS LIMPOS (06/10/2026).
//
// Embrulha o `createWebHistory` do vue-router: o roteador continua vendo e
// pedindo os endereços internos (`/app/accounts/1/processos/27`) e a barra do
// navegador, o histórico e os `href` dos links passam a ter os limpos
// (`/processos/27`). Rotas, nomes, guardas e os 83 lugares que leem
// `params.accountId` não mudam. Ver `docs/navegacao/README.md`.
import { createWebHistory } from 'vue-router';
import { contaPrincipal, marcarContaAtual } from './conta';
import { lerInterno, paraExterno, paraInterno } from './traducao';

// A conta de cada entrada do histórico vai junto no estado dela
// (`advupConta`). Quem usa mais de uma conta e troca a principal não tem o
// Voltar lendo `/processos/27` na conta nova: vale a conta daquela entrada.
const contaDaEntrada = () =>
  window.history.state?.advupConta || contaPrincipal();

const dentro = endereco => {
  const interno = paraInterno(endereco, contaDaEntrada());
  marcarContaAtual(lerInterno(interno)?.conta);
  return interno;
};
const fora = endereco => paraExterno(endereco, contaPrincipal());

export const criarHistoriaLimpa = (base = createWebHistory()) => ({
  get base() {
    return base.base;
  },
  get location() {
    return dentro(base.location);
  },
  get state() {
    return base.state;
  },
  push(para, dados) {
    const conta = lerInterno(para)?.conta;
    marcarContaAtual(conta);
    base.push(fora(para), { ...dados, advupConta: conta });
  },
  replace(para, dados) {
    const conta = lerInterno(para)?.conta;
    marcarContaAtual(conta);
    base.replace(fora(para), { ...dados, advupConta: conta });
  },
  go(delta, avisar) {
    base.go(delta, avisar);
  },
  listen(ouvinte) {
    return base.listen((para, de, info) =>
      ouvinte(dentro(para), dentro(de), info)
    );
  },
  createHref(endereco) {
    return base.createHref(fora(endereco));
  },
  destroy() {
    base.destroy();
  },
});
